import { Component } from '@angular/core';
import { Injectable } from "@angular/core";
import { CommonHttpService } from '../utils/common-http.service'
import constant from '../app.constant'
import * as _ from 'lodash';
@Injectable({
    providedIn: 'root'
})
export class UploadImageService {
    // http = new CommonHttpService();
    constructor(private http: CommonHttpService) { }


    public async imageUpload(event: any, data: any) {
        var file: FileList = event.target.files
        var fileToUpload = file.item(0);
        // if (data.first_id == undefined || !data.first_id) {
        //     if (fileToUpload) {
        //         var formData: FormData = new FormData();
        //         formData.append('uploadFile', fileToUpload, fileToUpload.name);
        //         formData.append('img_for', data.img_for);
        //         formData.append('img_type', data.img_type);
        //         formData.append('img_name', data.img_name);
        //         formData.append('first_id', 'tempId');
        //         formData.append('tempFile', 'tempCreate');
        //     };
        // } else {
        //     if (fileToUpload) {
        //         var formData: FormData = new FormData();
        //         formData.append('uploadFile', fileToUpload, fileToUpload.name);
        //         formData.append('img_for', data.img_for);
        //         formData.append('img_type', data.img_type);
        //         formData.append('img_name', data.img_name);
        //         formData.append('first_id', data.first_id);
        //     };
        // }
        // return await this.http.postData(constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.Create, formData).toPromise()
    }

}
